import React from "react";

interface Props {
  message: string;
  hint?: string;
  className?: string;
}

export const PlaceholderCard: React.FC<Props> = ({ message, hint, className }) => {
  return (
    <div
      className={`PlaceholderCard text-body-secondary small text-center py-3${className ? ` ${className}` : ""}`}
    >
      {message}
      {hint && (
        <>
          <br />
          <span className="text-muted">{hint}</span>
        </>
      )}
    </div>
  );
};
